module.exports = __webpack_public_path__ + "img/l1-a.d9c71a7d.png";